import React from 'react';

import { classNames } from '@/helpers/classNames';
import { useAuth } from '@/providers/AuthProvider';
import { useTeam } from '@/providers/TeamProvider';

import { ILayoutProps } from '../Layout';
import { UserAvatar } from '../UserAvatar';
import styles from './AccountMenu.module.scss';

interface AccountMenuProps {
	setAccountOpen: ILayoutProps['setAccountOpen'];
	className?: string;
}

const AccountMenu: React.FC<AccountMenuProps> = ({
	setAccountOpen,
	className,
}) => {
	const { user } = useAuth();
	const { team } = useTeam();

	return (
		<div
			className={classNames([styles['root'], className])}
			onClick={() => setAccountOpen({ open: true })}
		>
			<UserAvatar size="xx-small" userId={user.id} />
			<div className={styles['account-info']}>
				<span className={styles['name']}>{user.displayName}</span>
				<span className={styles['church']}>{team.name}</span>
			</div>
		</div>
	);
};

export default AccountMenu;
